<template>
  <div class="content">
    <!-- nav -->
    <div class="nav_header">
      <div class="container nav_content">
        <div class="head_logo">
          <img src="../assets/img/head_logo.png" alt="" />
        </div>
        <div class="nav_list">
          <div class="list_unit">首页</div>
          <div class="list_unit">竹筒酒的功能与作用</div>
          <div class="list_unit">竹筒酒适用人群</div>
          <div class="list_unit">竹筒酒的养生与文化</div>
          <div class="list_unit">竹城市CEO</div>
          <div class="list_unit">联系方式</div>
        </div>
        <!-- <div class="nav_phone">
          <img src="../assets/img/phone.png" alt="" />
          <span>13121092587</span>
        </div> -->
      </div>
    </div>
    <!-- 轮播 -->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="../assets/img/wine_background.jpg" alt="" />
        </div>
      </div>
      <!-- Add Arrows -->
      <!-- <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div> -->
    </div>
    <!-- TODO chanyelian -->
    <div class="chain">
      <div class="container chain_box">
        <div class="chain_title">中企红竹筒酒产业链</div>
        <div class="title_border"></div>
        <div class="chain_box_content">
          <div class="label">
            <img src="../assets/img/label_icon1.png" alt="" />
            <span>匠心耕耘</span>
            <p>
              “凌霜竹箭傲雪梅”，天生清雅，无意与百花草木争奇斗艳的竹子，无牡丹之富丽，无松柏之伟岸，无桃李之妖艳，或生长于山野，或绕溪成径。
            </p>
          </div>
          <div class="label">
            <img src="../assets/img/label_icon2.png" alt="" />
            <span>潜心培育</span>
            <p>
              “凌霜竹箭傲雪梅”，天生清雅，无意与百花草木争奇斗艳的竹子，无牡丹之富丽，无松柏之伟岸，无桃李之妖艳，或生长于山野，或绕溪成径。
            </p>
          </div>
          <div class="label">
            <img src="../assets/img/label_icon3.png" alt="" />
            <span>精心酿造</span>
            <p>
              “凌霜竹箭傲雪梅”，天生清雅，无意与百花草木争奇斗艳的竹子，无牡丹之富丽，无松柏之伟岸，无桃李之妖艳，或生长于山野，或绕溪成径。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- TODO shenghuofangshi -->
    <div class="lifeType">
      <div class="container lifeType_box">
        <div class="type_title">基于竹筒酒的现代生活方式</div>
        <div class="title_border"></div>
        <div class="type_box_content">
          <div class="life_label">
            <img src="../assets/img/life_icon1.png" alt="" />
            <span>竹筒酒传承</span>
            <p>健康是传承，源于前人智慧，更新是 现代的生活方式</p>
          </div>
          <div class="life_label">
            <img src="../assets/img/life_icon2.png" alt="" />
            <span>竹筒酒礼物</span>
            <p>健康是传承，源于前人智慧，更新是 现代的生活方式</p>
          </div>
          <div class="life_label">
            <img src="../assets/img/life_icon3.png" alt="" />
            <span>竹筒酒运动</span>
            <p>健康是传承，源于前人智慧，更新是 现代的生活方式</p>
          </div>
        </div>
      </div>
    </div>
    <!-- TODO hangye -->
    <div class="industry">
      <div class="container industry_box">
        <img class="industry_bg" src="../assets/img/industry_bg.png" alt="" />
        <div class="industry_box_content">
          <div class="industry_title">
            <div class="title">酒席上的低调奢华：竹筒酒行业</div>
            <div class="title_borders"></div>
          </div>
          <div class="industry_label">
            <img src="../assets/img/industry_icon1.png" alt="" />
            <img src="../assets/img/industry_icon2.png" alt="" />
            <img src="../assets/img/industry_icon3.png" alt="" />
          </div>
          <div class="industry_tab">
            <div class="tab_word">
              <p style="font-size: 20px; color: #8afda5">竹筒酒酒精度（vol）</p>
              <p style="font-size: 32px; color: #fff; font-weight: bold">52</p>
            </div>
            <div class="tab_word">
              <p style="font-size: 20px; color: #8afda5">竹筒酒净含量（ml）</p>
              <p style="font-size: 32px; color: #fff; font-weight: bold">510</p>
            </div>
            <div class="tab_word">
              <p style="font-size: 20px; color: #8afda5">竹筒酒保质期（年）</p>
              <p style="font-size: 32px; color: #fff; font-weight: bold">1</p>
            </div>
            <div class="tab_word">
              <p style="font-size: 20px; color: #8afda5">竹筒酒时间年份</p>
              <p style="font-size: 32px; color: #fff; font-weight: bold">
                2022
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- TODO chanpin -->
    <div class="product">
      <img class="product_bg" src="../assets/img/product_bg.png" alt="" />
      <div class="container product_box">
        <div class="product_title">中企红竹筒酒产品</div>
        <div class="title_border"></div>
        <div class="product_box_content">
          <div class="product_detail">
            <div class="product_line1">竹筒酒</div>
            <div class="product_line2">国台好酱酒 更多人享受</div>
            <div class="product_line3">
              正宗的酱香工艺，更高的性价比，让更 多人都能享受到酱香好酒
            </div>
            <img class="product_line4" src="../assets/img/wine.png" alt="" />
          </div>
          <div class="product_border"></div>
          <div class="product_detail">
            <div class="product_line1">竹筒酒</div>
            <div class="product_line2">国台好酱酒 更多人享受</div>
            <div class="product_line3">
              正宗的酱香工艺，更高的性价比，让更 多人都能享受到酱香好酒
            </div>
            <img class="product_line4" src="../assets/img/wine.png" alt="" />
          </div>
          <div class="product_border"></div>
          <div class="product_detail">
            <div class="product_line1">竹筒酒</div>
            <div class="product_line2">国台好酱酒 更多人享受</div>
            <div class="product_line3">
              正宗的酱香工艺，更高的性价比，让更 多人都能享受到酱香好酒
            </div>
            <img class="product_line4" src="../assets/img/wine.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- TODO toutiao -->
    <div class="headlines">
      <div class="container headlines_box">
        <div class="headlines_title">爱喝中企红竹筒酒</div>
        <div class="headlines_tips">
          喝酒，喝好酒，选择中企红，好喝健康不上头
        </div>
        <div class="headlines_box_content">
          <div class="list">
            <div class="list_img">
              <img src="../assets/img/msg_bg.png" alt="" />
            </div>
            <div class="list_title">再获两项大奖，人民网国民消人民网国民消</div>
            <div class="list_content">
              酒类和水类的统称，可指酒、水、饮料等液体可饮用的水，用来招待客人的液体。此词主要应用于餐饮界。酒的化学成分是乙醇，一般含有微量的杂醇和酯类物质
            </div>
            <div class="list_time">2022.03.30</div>
          </div>
          <div class="list">
            <div class="list_img">
              <img src="../assets/img/msg_bg.png" alt="" />
            </div>
            <div class="list_title">再获两项大奖，人民网国民消人民网国民消</div>
            <div class="list_content">
              酒类和水类的统称，可指酒、水、饮料等液体可饮用的水，用来招待客人的液体。此词主要应用于餐饮界。酒的化学成分是乙醇，一般含有微量的杂醇和酯类物质
            </div>
            <div class="list_time">2022.03.30</div>
          </div>
          <div class="list">
            <div class="list_img">
              <img src="../assets/img/msg_bg.png" alt="" />
            </div>
            <div class="list_title">再获两项大奖，人民网国民消人民网国民消</div>
            <div class="list_content">
              酒类和水类的统称，可指酒、水、饮料等液体可饮用的水，用来招待客人的液体。此词主要应用于餐饮界。酒的化学成分是乙醇，一般含有微量的杂醇和酯类物质
            </div>
            <div class="list_time">2022.03.30</div>
          </div>
        </div>
      </div>
    </div>
    <!-- TODO zhaoshangjiameng -->
    <div class="attract">
      <div class="container attract_box">
        <div class="attract_title">新奇特产品招商加盟</div>
        <div class="title_border"></div>
        <div class="attract_box_content">
          <div class="attract_bg">
            <img src="../assets/img/join_bg.png" alt="" />
          </div>
          <div class="introduce">
            <div class="introduce_box">
              <div class="introduce_box_title">实力招商</div>
              <div class="introduce_box_content">
                酒类和水类的统称，可指酒、水、饮料等液体可饮用的水，用来招待客人的液体。此词主要应用于餐饮界。酒的化学成分是乙醇，一般含有微量的杂醇和酯类物质酒类和水类的统称，可指酒、水、饮料等液体可饮用的水，用来招待客人的液体。此词主要应用于餐饮界。酒的化学成分是乙醇，一般含有微量的杂醇和酯类物质.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- TODO ziliao -->
    <div class="data">
      <div class="container data_box">
        <div class="data_title">酒厂内部招商资料揭秘</div>
        <div class="title_border"></div>
        <div class="data_box_content">
          <div class="user_phone">
            <span>电话（已加密）*</span>
            <input type="text" placeholder="请输入手机号" />
          </div>
          <div class="user_manual">
            <span>酒厂招商手册：代理加盟费用、条件、利润、区域等</span>
            <select name="" id="">
              <option value="代理加盟费用">代理加盟费用</option>
              <option value="条件">条件</option>
              <option value="利润">利润</option>
              <option value="区域">区域</option>
            </select>
          </div>
        </div>
        <div class="receive">点击免费领取</div>
      </div>
    </div>
    <!-- TODO foot -->
    <div class="foot">
      <div class="container foot_box">
        <div class="foot_nav">
          <span>网站首页</span>
          <span>|</span>
          <span>关于我们</span>
          <span>|</span>
          <span>竹筒酒知识</span>
          <span>|</span>
          <span>产品展示</span>
          <span>|</span>
          <span>行业动向</span>
          <span>|</span>
          <span>竹筒酒营养</span>
          <span>|</span>
          <span>招商加盟</span>
          <span>|</span>
          <span>联系我们</span>
        </div>
        <div class="foot_detail">
          <div class="foot_logo">
            <img src="../assets/img/head_logo.png" alt="" />
          </div>
          <div class="foot_content">
            <span style="margin-top: 0">联系方式：400-010-9989</span>
            <span>地址：北京市大兴区星光影视圆北区B3-5</span>
            <span @click="jump"
              >京ICP备20025162号-8 京ICP证 京B2-20191350号</span
            >
            <span>中企虹投资管理有限公司</span>
          </div>
          <div class="foot_code">
            <div class="code">
              <img src="../assets/img/group_code.png" alt="" />
            </div>
            <span>私董会社群</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
$(function () {
  var swiper = new Swiper(".swiper-container", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});
export default {
  name: "index",
  data() {
    return {};
  },
  methods: {
    jump() {
      window.open("https://beian.miit.gov.cn/");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../assets/css/index.css";
</style>



// WEBPACK FOOTER //
// src/components/index.vue